// import React from 'react';

// const LoadingShopCard = () => {
//   return (
//     <div className="bg-surface border border-border rounded-xl overflow-hidden animate-pulse">
//       {/* Image Skeleton */}
//       <div className="h-40 bg-muted"></div>

//       {/* Content Skeleton */}
//       <div className="p-4 space-y-3">
//         {/* Title */}
//         <div className="h-6 bg-muted rounded w-3/4"></div>
        
//         {/* Address */}
//         <div className="space-y-2">
//           <div className="h-4 bg-muted rounded w-full"></div>
//           <div className="h-4 bg-muted rounded w-2/3"></div>
//         </div>

//         {/* Info */}
//         <div className="flex justify-between">
//           <div className="h-4 bg-muted rounded w-24"></div>
//           <div className="h-4 bg-muted rounded w-16"></div>
//         </div>

//         {/* Products Preview */}
//         <div className="pt-3 border-t border-border">
//           <div className="h-3 bg-muted rounded w-32 mb-2"></div>
//           <div className="flex gap-2">
//             <div className="w-16 h-16 bg-muted rounded-lg"></div>
//             <div className="w-16 h-16 bg-muted rounded-lg"></div>
//             <div className="w-16 h-16 bg-muted rounded-lg"></div>
//           </div>
//         </div>

//         {/* Button */}
//         <div className="h-10 bg-muted rounded-lg mt-4"></div>
//       </div>
//     </div>
//   );
// };

// export default LoadingShopCard;

import React from 'react';

const LoadingShopCard = () => {
  return (
    <div className="bg-surface border border-border rounded-xl overflow-hidden animate-pulse">
      {/* Image Skeleton */}
      <div className="h-40 bg-muted"></div>

      {/* Content Skeleton */}
      <div className="p-4 space-y-3">
        {/* Title */}
        <div className="h-6 bg-muted rounded w-3/4"></div>
        
        {/* Address */}
        <div className="space-y-2">
          <div className="h-4 bg-muted rounded w-full"></div>
          <div className="h-4 bg-muted rounded w-2/3"></div>
        </div>

        {/* Info */}
        <div className="flex justify-between">
          <div className="h-4 bg-muted rounded w-24"></div>
          <div className="h-4 bg-muted rounded w-16"></div>
        </div>

        {/* Products Preview */}
        <div className="pt-3 border-t border-border">
          <div className="h-3 bg-muted rounded w-32 mb-2"></div>
          <div className="flex gap-2">
            <div className="w-16 h-16 bg-muted rounded-lg"></div>
            <div className="w-16 h-16 bg-muted rounded-lg"></div>
            <div className="w-16 h-16 bg-muted rounded-lg"></div>
          </div>
        </div>

        {/* Button */}
        <div className="h-10 bg-muted rounded-lg mt-4"></div>
      </div>
    </div>
  );
};

export default LoadingShopCard;
